import KryptonCardForm from '@/host/components/controls/CardForm'
import KryptonFormError from '@/host/components/controls/KryptonFormError'
import KryptonDiscountPanel from '@/host/components/controls/KryptonDiscountPanel'
import KryptonPaymentButton from '@/host/components/controls/KryptonPaymentButton'
import KryptonBrandButtons from '@/host/components/controls/KryptonBrandButtons'
import KryptonLayerManager from '@/host/components/controls/KryptonLayerManager'
import KryptonPopinWrapper from '@/host/components/popin/KryptonPopinWrapper'
import KryptonPopinHeaderWrapper from '@/host/components/popin/KryptonPopinHeaderWrapper'
import KryptonPopinFooter from '@/host/components/popin/KryptonPopinFooter'
import KryptonInstallments from '@/host/components/fields/KryptonInstallments'
import KryptonFirstInstallmentDelay from '@/host/components/fields/KryptonFirstInstallmentDelay'
import KryptonDoRegister from '@/host/components/fields/KryptonDoRegister'
import KryptonIdentityDocType from '@/host/components/fields/KryptonIdentityDocType'
import KryptonIdentityDocNumber from '@/host/components/fields/KryptonIdentityDocNumber'
import KryptonCardHolderName from '@/host/components/fields/KryptonCardHolderName'
import KryptonCardHolderMail from '@/host/components/fields/KryptonCardHolderMail'
import KryptonField from '@/host/components/fields/KryptonField'
import KryptonLayer from '@/host/components/controls/KryptonLayer'
import KryptonCurrencyConversion from '@/host/components/controls/CurrencyConversion'
import KryptonWalletTabs from '@/host/components/wallet/KryptonWalletTabs'
import KryptonWalletCardList from '@/host/components/wallet/KryptonWalletCardList'

export const registerGlobalComponents = Vue => {
  Vue.component('KryptonCardForm', KryptonCardForm)
  Vue.component('KryptonFormError', KryptonFormError)
  Vue.component('KryptonDiscountPanel', KryptonDiscountPanel)
  Vue.component('KryptonPaymentButton', KryptonPaymentButton)
  Vue.component('KryptonBrandButtons', KryptonBrandButtons)
  Vue.component('KryptonLayerManager', KryptonLayerManager)
  Vue.component('KryptonPopinWrapper', KryptonPopinWrapper)
  Vue.component('KryptonPopinHeaderWrapper', KryptonPopinHeaderWrapper)
  Vue.component('KryptonPopinFooter', KryptonPopinFooter)
  Vue.component('KryptonInstallments', KryptonInstallments)
  Vue.component('KryptonFirstInstallmentDelay', KryptonFirstInstallmentDelay)
  Vue.component('KryptonDoRegister', KryptonDoRegister)
  Vue.component('KryptonIdentityDocType', KryptonIdentityDocType)
  Vue.component('KryptonIdentityDocNumber', KryptonIdentityDocNumber)
  Vue.component('KryptonCardHolderName', KryptonCardHolderName)
  Vue.component('KryptonCardHolderMail', KryptonCardHolderMail)
  Vue.component('KryptonField', KryptonField)
  Vue.component('KryptonLayer', KryptonLayer)
  Vue.component('KryptonCurrencyConversion', KryptonCurrencyConversion)
  Vue.component('KryptonWalletTabs', KryptonWalletTabs)
  Vue.component('KryptonWalletCardList', KryptonWalletCardList)
}
